// extracted by mini-css-extract-plugin
export default {"root":"PrivateRouter_root__nQUi-","page":"PrivateRouter_page__Hpf4d"};